module.exports = __webpack_public_path__ + "static/media/photo-filled.e8c5c5da.svg";